import { useCallback, useState } from 'react';

import useFetch from 'hooks/useFetch';

import { JOHN_DEERE_FIELDS_API } from './constants';
import type { JohnDeereField, UseJohnDeereFieldsReturn } from './types';

const FETCH_PARAMS = {
    apiHost: import.meta.env.VITE_JD_API_BASE_URL || '',
    headers: { 'Content-Type': 'application/json' }
};

const useJohnDeereFields = (): UseJohnDeereFieldsReturn => {
    const [fields, setFields] = useState<JohnDeereField[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const { authenticatedGet } = useFetch(FETCH_PARAMS);

    const fetch = useCallback(
        async ({ organizationId }: { organizationId: string }) => {
            try {
                setIsLoading(true);

                const response = await authenticatedGet<JohnDeereField[]>(
                    `${JOHN_DEERE_FIELDS_API}/${organizationId}/fields`
                );

                if (response.data) {
                    setFields(response.data);
                }

                if (response.error) {
                    console.error('Failed to fetch JD fields:', response.error);
                }
            } finally {
                setIsLoading(false);
            }
        },
        [authenticatedGet]
    );

    return {
        fetch,
        fields,
        isLoading
    };
};

export default useJohnDeereFields;
